import PropertyTableCell from './components/PropertyTableCell';
export default PropertyTableCell;